<meta charset="utf-8">

<h4>Categorias</h4>

<button *ngIf="editable" class="btn btn-primary" (click)="clickAddCategoria()">Añadir categoria</button>

<table class="table table-striped" *ngIf="categorias && categorias.length > 0">
  <thead>
    <tr>
      <th>Nombre</th>
      <th></th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let categoria of categorias, let index = index">
      <td>{{categoria.nombre}}</td>
      <td><button *ngIf="editable" class="btn btn-primary btn-edit" (click)="handleEditClick(categoria)">Editar</button></td>
    </tr>
  </tbody>
</table>